import { render, staticRenderFns } from "./resource-item-operate-log-dialog.vue?vue&type=template&id=52995168&scoped=true"
import script from "./resource-item-operate-log-dialog.vue?vue&type=script&lang=js"
export * from "./resource-item-operate-log-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52995168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52995168')) {
      api.createRecord('52995168', component.options)
    } else {
      api.reload('52995168', component.options)
    }
    module.hot.accept("./resource-item-operate-log-dialog.vue?vue&type=template&id=52995168&scoped=true", function () {
      api.rerender('52995168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/resource-item-operate-log-dialog.vue"
export default component.exports